import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import styled, { css } from 'styled-components';

const Wrapper = styled.div<{ isOpen: boolean; showBottomBorder?: boolean }>`
  display: inline-flex;
  position: relative;
  flex-direction: column;
  padding-bottom: 10px;
  min-width: 240px;
  max-width: 360px;
  z-index: 2;
  cursor: pointer;

  ${(props) =>
    props.showBottomBorder
      ? css`
          border-bottom: 1px solid ${brand.grey[85]};
        `
      : css`
          padding-bottom: 0px;
        `};

  ${({ isOpen }) =>
    isOpen
      ? css`
          background-color: ${brand.grey[95]};
        `
      : null}
`;

const Label = styled.span`
  ${fonts.helvetica['87-heavy-condensed']};
  font-size: 15px;
  color: ${brand.grey[45]};
  margin-bottom: 6px;
  text-transform: capitalize;
`;

const Value = styled.span<{ isPlaceholder?: boolean }>`
  ${fonts.helvetica['87-heavy-condensed']};
  font-size: 18px;
  position: relative;
  padding-right: 24px;

  ${(props) =>
    props.isPlaceholder
      ? css`
          height: 16px;
          color: ${brand.red.base};
          ${fonts.helvetica['87-heavy-condensed']}
        `
      : css`
          color: unset;
        `};

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 4px;
    background-color: ${brand.black};
    width: 12px;
    height: 6px;
    clip-path: polygon(50% 100%, 0 0, 100% 0);
    display: block;
  }
`;

const Dropdown = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 100%;
  background: ${brand.grey[95]};
  width: 100%;
  left: 0px;
  padding: 4px;
  max-height: 302px;
  overflow: auto;
  display: none;

  ${({ isOpen }) =>
    isOpen
      ? css`
          display: block;
        `
      : null}
`;

const Search = styled.input`
  width: 100%;
  border: none;
  margin-bottom: 4px;
  ${fonts.helvetica['55-roman']};
  padding: 4px;
  font-size: 14px;
`;

const Options = styled.div``;

const Option = styled.button.attrs({ type: 'button' })<{ selected: boolean }>`
  border: none;
  background: none;
  outline: none;
  padding: 4px;
  display: block;
  width: 100%;
  text-align: left;
  ${fonts.helvetica['55-roman']};
  border-bottom: 1px solid ${brand.grey[85]};
  font-size: 14px;

  ${({ selected }) =>
    selected
      ? css`
          background: ${brand.grey['90']};
        `
      : null}

  &:hover {
    background: ${brand.white};
  }

  &:last-child {
    border-bottom: none;
  }
`;

const NoResults = styled.div`
  padding: 4px;
  ${fonts.helvetica['55-roman']};
`;

export const SearchableSelectStyles = {
  Wrapper,
  Label,
  Value,
  Dropdown,
  Search,
  Options,
  Option,
  NoResults,
};
